document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.available-offers-scroll');
  sliders.forEach(slider => {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.style.scrollBehavior = 'auto';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.style.scrollBehavior = 'smooth';
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.style.scrollBehavior = 'smooth';
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5; // Scroll speed
      slider.scrollLeft = scrollLeft - walk;
    });
  });
});
